import SiteStore from "./SiteStore";
import UserStore from "./UserStore";

class ApplicationStore {
  user = new UserStore();
  site = new SiteStore();
}

export default new ApplicationStore();
